var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1018",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.666 16.6667V23.3333H16.666V35H23.3327V23.3333H28.3327L29.9993 16.6667H23.3327V13.3333C23.3327 12.8913 23.5083 12.4674 23.8208 12.1548C24.1334 11.8423 24.5573 11.6667 24.9993 11.6667H29.9993V5H24.9993C22.7892 5 20.6696 5.87797 19.1068 7.44078C17.544 9.00358 16.666 11.1232 16.666 13.3333V16.6667H11.666Z",
    stroke: "#3B5999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.db5cfbd03d005ae76394e424b32b8810.svg";
export { ForwardRef as ReactComponent };